import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, MessageCircle } from 'lucide-react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Pricing',
    href: '/pricing'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md" data-id="element-92">
      <Container data-id="element-93">
        <div className="flex h-16 items-center justify-between" data-id="element-94">
          <Link to="/" className="flex items-center" aria-label="Brixen Credit home" data-id="element-95">
            <img src="https://cdn.magicpatterns.com/uploads/pBeDZwLFT6NbwtKUvYGrxZ/Asset_21x.png" alt="Brixen Credit" className="h-8 w-auto" data-id="element-96" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-97">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`text-sm font-medium transition-colors hover:text-blue-600 ${isActive(item.href) ? 'text-blue-600' : 'text-slate-600'}`} data-id="element-98">
                {item.name}
              </Link>)}
            <a href="https://wa.me/17863763985" target="_blank" rel="noopener noreferrer" data-id="element-99">
              <Button size="sm" data-id="element-100">
                <MessageCircle className="h-4 w-4 mr-2" data-id="element-101" />
                Contact Us
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-102">
            {isMenuOpen ? <X className="h-6 w-6" data-id="element-103" /> : <Menu className="h-6 w-6" data-id="element-104" />}
          </button>
        </div>
      </Container>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden border-t border-slate-200 bg-white" data-id="element-105">
          <Container className="py-4 space-y-4" data-id="element-106">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`block text-base font-medium ${isActive(item.href) ? 'text-blue-600' : 'text-slate-600'}`} onClick={() => setIsMenuOpen(false)} data-id="element-107">
                {item.name}
              </Link>)}
            <a href="https://wa.me/17863763985" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)} className="block pt-2" data-id="element-108">
              <Button className="w-full" data-id="element-109">
                <MessageCircle className="h-4 w-4 mr-2" data-id="element-110" />
                Contact Us
              </Button>
            </a>
          </Container>
        </div>}
    </header>;
}